import api from '../../services/api';

export const blocksApi = {
  async getBlocks(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value);
      }
    });

    const response = await api.get(`/blocks?${searchParams.toString()}`);
    return response.data;
  },

  async getBlockById(id) {
    const response = await api.get(`/blocks/${id}`);
    return response.data;
  },

  async updateBlock(id, blockData) {
    const response = await api.put(`/blocks/${id}`, blockData);
    return response.data;
  },

  async createBlock(blockData) {
    const response = await api.post('/blocks', blockData);
    return response.data;
  },

  async deleteBlock(id) {
    const response = await api.delete(`/blocks/${id}`);
    return response.data;
  }
};

export default blocksApi;